module.exports = __webpack_public_path__ + "img/blog-advertising.47fd5410.jpg";